


// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { TextField, Button, Typography, Container, Grid } from '@mui/material';
// import { sendPasswordResetEmail } from '../features/userSlice'; // פעולה לשליחת מייל לשחזור סיסמה

// const ForgotPassword = () => {
//   const [email, setEmail] = useState('');
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const handleChangeEmail = (event) => {
//     setEmail(event.target.value);
//     setError('');
//     setSuccess('');
//   };

//   const handleSubmit = () => {
//     if (!/\S+@\S+\.\S+/.test(email)) {
//       setError('כתובת האימייל אינה חוקית');
//       return;
//     }

//     dispatch(sendPasswordResetEmail(email))
//       .then(response => {
//         if (response.error) {
//           setError('שגיאה בשליחת מייל לשחזור סיסמה');
//         } else {
//           setSuccess('מייל לשחזור סיסמה נשלח בהצלחה');
//         }
//       })
//       .catch(err => setError('שגיאה בשליחת מייל לשחזור סיסמה'));
//   };

//   return (
//     <Container maxWidth="xs" style={{ marginTop: '150px' }}>
//       <Typography variant="h4" align="center" gutterBottom>
//         שחזור סיסמה
//       </Typography>
//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <TextField
//             label="כתובת מייל"
//             name="email"
//             type="email"
//             fullWidth
//             onChange={handleChangeEmail}
//             value={email}
//           />
//         </Grid>
//       </Grid>
//       <Button
//         type="button"
//         variant="contained"
//         color="primary"
//         fullWidth
//         onClick={handleSubmit}
//       >
//         שלח קישור לשחזור סיסמה
//       </Button>
      
//       {error && <Typography color="error">{error}</Typography>}
//       {success && <Typography color="primary">{success}</Typography>}
//     </Container>
//   );
// };

// export default ForgotPassword;
import React, { useState } from "react";
import { Button, TextField, Typography, Container } from "@mui/material";
import { ForgotPassword } from "../utils/usersAPI";
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setError("");
    setMessage("");

    if (!email) {
      setError("יש להזין מייל");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("כתובת מייל לא תקינה");
      return;
    }

    try {
      const res = await ForgotPassword(email.trim());
      setMessage(res.data);
    } catch (err) {
      setError(err.response?.data || "אירעה שגיאה");
    }
  };

  return (
    <Container maxWidth="xs" style={{ marginTop: "140px" }}>
      <Typography variant="h4" align="center" gutterBottom>
        שכחת סיסמה
      </Typography>

      <TextField
        label="כתובת מייל"
        type="email"
        fullWidth
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <br /><br />

      <Button variant="contained" fullWidth onClick={handleSubmit}>
        שליחת קישור לאיפוס סיסמה
      </Button>

      {message && <Typography color="green">{message}</Typography>}
      {error && <Typography color="error">{error}</Typography>}

      <br />

      <Button fullWidth onClick={() => navigate("/signIn")}>
        חזרה להתחברות
      </Button>
    </Container>
  );
};

export default ForgotPasswordPage;